import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)

// const access_levels_array = {
//   "1": {
//     value: "admin",
//   },
//   "2": {
//     value: "author"
//   }
// }

export default new Router({
  routes: [
    {
      base: process.env.VUE_APP_PREFIX,
      path: "/",
      component: () =>
        import(/* webpackChunkName: "default" */ "./layouts/default"),
      meta: {
        access_group: [1, 2]
      },

      children: [
        {
          path: "",
          name: "index",
          component: () =>
            import(/* webpackChunkName: "index-page" */ "./views"),
          // redirect: "/group"
          meta: {
            access_group: [1, 2]
          }
        },

        // category create

        {
          path: "/category/create",
          name: "category-create",
          component: () =>
            import(
              /* webpackChunkName: "category-create" */
              "./views/category/category-create"
            ),
          meta: {
            access_group: [1, 2]
          }
        },

        // category edit
        {
          path: "/category/:cat_id",
          name: "category-edit",
          component: () =>
            import(
              /* webpackChunkName: "category-edit" */
              "./views/category/category-create"
            ),
          meta: {
            parent: "categories",
            access_group: [1, 2]
          }
        },

        // category news list
        {
          path: "/category/:cat_id/list",
          name: "category-news",
          component: () =>
            import(
              /* webpackChunkName: "category-news" */
              "./views/category/category-news"
            ),
          meta: {
            parent: "categories",
            access_group: [1, 2]
          }
        },

        // news create
        {
          path: "/news-create/:cat_id",
          name: "news-create",
          component: () =>
            import(
              /* webpackChunkName: "news-create" */
              "./views/news/news-detail"
            ),
          meta: {
            parent: "categories",
            access_group: [1, 2]
          }
        },

        // news detail
        {
          path: "/news/:id",
          name: "news-detail",
          component: () =>
            import(
              /* webpackChunkName: "news-detail" */
              "./views/news/news-detail"
            ),
          meta: {
            parent: "categories",
            access_group: [1, 2]
          }
        },

        // catego

        // users
        {
          path: "/users",
          name: "users",
          component: () =>
            import(/* webpackChunkName: "users" */ "./views/users"),
          meta: {
            dataUrl: "users",
            parent: "users",
            title: {
              uz: "Foydalanuvchilar",
              oz: "Фойдаланувчилар",
              ru: "Пользователи",
              en: "Users"
            },
            iconName: "team",
            // hideProd: true,
            access_group: [1]
          }
        },

        // user create
        {
          path: "/user/create",
          name: "user-create",
          component: () =>
            import(
              /* webpackChunkName: "user-create" */
              "./views/users/detail"
            ),
          meta: {
            parent: "users",
            access_group: [1]
          }
        },

        // user detail
        {
          path: "/user/:id",
          name: "user-detail",
          component: () =>
            import(
              /* webpackChunkName: "user-detail" */
              "./views/users/detail"
            ),
          meta: {
            parent: "users",
            access_group: [1]
          }
        },

        // menu
        {
          path: "/menu",
          name: "menu",
          component: () =>
            import(/* webpackChunkName: "menu-list" */ "./views/menu"),
          meta: {
            dataUrl: "menu",
            title: {
              uz: "Menyu",
              oz: "Меню",
              ru: "Меню",
              en: "Menu"
            },
            iconName: "hdd",
            access_group: [1]
          }
        },

        // menu detail
        {
          path: "/menu/create",
          name: "menu-create",
          component: () =>
            import(/* webpackChunkName: "menu-create" */ "./views/menu/detail"),
          meta: {
            parent: "menu",
            access_group: [1]
          }
        },

        // menu detail
        {
          path: "/menu/:id",
          name: "menu-detail",
          component: () =>
            import(/* webpackChunkName: "menu-detail" */ "./views/menu/detail"),
          meta: {
            parent: "menu",
            access_group: [1]
          }
        },

        // static pages
        {
          path: "/pages",
          name: "pages",
          component: () =>
            import(/* webpackChunkName: "pages" */ "./views/pages"),
          meta: {
            dataUrl: "pages",
            title: {
              uz: "Sahifalar",
              oz: "Саҳифалар",
              ru: "Страницы",
              en: "Pages"
            },
            iconName: "book",
            hideProd: false,
            access_group: [1]
          }
        },

        // static page create
        {
          path: "/pages/create",
          name: "Pages-create",
          component: () =>
            import(/* webpackChunkName: "pages" */ "./views/pages/detail"),
          meta: {
            parent: "pages",
            access_group: [1]
          }
        },

        // static page detail
        {
          path: "/pages/:id",
          name: "Pages-detail",
          component: () =>
            import(/* webpackChunkName: "pages" */ "./views/pages/detail"),
          meta: {
            parent: "pages",
            access_group: [1]
          }
        },

        // news
        {
          path: "/news",
          name: "news",
          component: () =>
            import(/* webpackChunkName: "news-category" */ "./views/news"),
          meta: {
            dataUrl: "news",
            iconName: "read",
            hideProd: false,
            parent: "news",
            title: {
              uz: "Yangiliklar",
              oz: "Янгиликлар",
              ru: "Новости",
              en: "News"
            },

            access_group: [1, 2]
          }
        },
        {
          path: "/category",
          name: "category",
          component: () =>
            import(/* webpackChunkName: "news-category" */ "./views/category"),
          meta: {
            dataUrl: "categories",
            iconName: "read",
            hideProd: false,
            parent: "categories",
            title: {
              uz: "Категории",
              oz: "Категории",
              ru: "Категории",
              en: "Categories"
            },

            access_group: [1, 2]
          }
          // children: []
        },
        // events
        {
          path: "/category-events/create",
          name: "category-events-create",
          component: () =>
            import(
              /* webpackChunkName: "category-create" */
              "./views/category-events/category-events-create"
            ),
          meta: {
            parent: "events",
            access_group: [1]
          }
        },

        // category EVENTS edit
        {
          path: "/category-events/:cat_id",
          name: "category-events-edit",
          component: () =>
            import(
              /* webpackChunkName: "category-edit" */
              "./views/category-events/category-events-create"
            ),
          meta: {
            parent: "events",
            access_group: [1]
          }
        },

        // category EVENTS list
        {
          path: "/category-events/:cat_id/list",
          name: "category-events-list",
          component: () =>
            import(
              /* webpackChunkName: "category-evemts" */
              "./views/category-events/category-events-list"
            ),
          meta: {
            parent: "events",
            access_group: [1]
          }
        },

        // events create
        {
          path: "/events-create/:cat_id",
          name: "events-create",
          component: () =>
            import(
              /* webpackChunkName: "events-create" */
              "./views/events/events-detail"
            ),
          meta: {
            parent: "events",
            access_group: [1]
          }
        },

        // events detail
        {
          path: "/events/:id",
          name: "events-detail",
          component: () =>
            import(
              /* webpackChunkName: "events-detail" */
              "./views/events/events-detail"
            ),
          meta: {
            parent: "events",
            access_group: [1]
          }
        },

        // events
        {
          path: "/category-events",
          name: "category-events",
          component: () =>
            import(
              /* webpackChunkName: "news-category" */ "./views/category-events"
            ),
          meta: {
            dataUrl: "events",
            iconName: "calendar",
            hideProd: true,
            parent: "events",
            title: {
              uz: "События",
              oz: "События",
              ru: "События",
              en: "Events"
            },
            access_group: [1]
          }
        },

        // alerts
        {
          path: "/category-alerts/create",
          name: "category-alerts-create",
          component: () =>
            import(
              /* webpackChunkName: "category-create" */
              "./views/category-alerts/category-alerts-create"
            ),
          meta: {
            parent: "alerts",
            access_group: [1]
          }
        },

        // category alerts edit
        {
          path: "/category-alerts/:cat_id",
          name: "category-alerts-edit",
          component: () =>
            import(
              /* webpackChunkName: "category-edit" */
              "./views/category-alerts/category-alerts-create"
            ),
          meta: {
            parent: "alerts",
            access_group: [1]
          }
        },

        // category alerts list
        {
          path: "/category-alerts/:cat_id/list",
          name: "category-alerts-list",
          component: () =>
            import(
              /* webpackChunkName: "category-evemts" */
              "./views/category-alerts/category-alerts-list"
            ),
          meta: {
            parent: "alerts",
            access_group: [1]
          }
        },

        // alerts create
        {
          path: "/alerts-create/:cat_id",
          name: "alerts-create",
          component: () =>
            import(
              /* webpackChunkName: "alerts-create" */
              "./views/alerts/alerts-detail"
            ),
          meta: {
            parent: "alerts",
            access_group: [1]
          }
        },

        // alerts detail
        {
          path: "/alerts/:id",
          name: "alerts-detail",
          component: () =>
            import(
              /* webpackChunkName: "alerts-detail" */
              "./views/alerts/alerts-detail"
            ),
          meta: {
            parent: "alerts",
            access_group: [1]
          }
        },

        // alerts
        {
          path: "/category-alerts",
          name: "category-alerts",
          component: () =>
            import(
              /* webpackChunkName: "news-category" */ "./views/category-alerts"
            ),
          meta: {
            dataUrl: "alerts",
            iconName: "alert",
            hideProd: true,
            parent: "alerts",
            title: {
              uz: "Объявления",
              oz: "Объявления",
              ru: "Объявления",
              en: "alerts"
            },
            access_group: [1]
          }
        },
        // category infographics list
        {
          path: "/infographics/list",
          name: "infographics-list",
          component: () =>
            import(
              /* webpackChunkName: "category-evemts" */
              "./views/infographics"
            ),
          meta: {
            dataUrl: "infographics",
            iconName: "audit",
            hideProd: true,
            parent: "infographics",
            title: {
              uz: "Инфографика",
              oz: "Инфографика",
              ru: "Инфографика",
              en: "Infographics"
            },
            access_group: [1]
          }
        },

        // infographics create
        {
          path: "/infographics-create",
          name: "infographics-create",
          component: () =>
            import(
              /* webpackChunkName: "infographics-create" */
              "./views/infographics/infographics-detail"
            ),
          meta: {
            parent: "infographics",
            access_group: [1]
          }
        },

        // infographics detail
        {
          path: "/infographics/:id",
          name: "infographics-detail",
          component: () =>
            import(
              /* webpackChunkName: "smi-detail" */
              "./views/infographics/infographics-detail"
            ),
          meta: {
            parent: "infographics",
            access_group: [1]
          }
        },
        // category smi list
        {
          path: "/smi/list",
          name: "smi-list",
          component: () =>
            import(
              /* webpackChunkName: "category-evemts" */
              "./views/smi"
            ),
          meta: {
            dataUrl: "smi",
            iconName: "link",
            hideProd: true,
            parent: "smi",
            title: {
              uz: "СМИ о Нас",
              oz: "СМИ о Нас",
              ru: "СМИ о Нас",
              en: "Mass media about us"
            },
            access_group: [1]
          }
        },

        // smi create
        {
          path: "/smi-create",
          name: "smi-create",
          component: () =>
            import(
              /* webpackChunkName: "smi-create" */
              "./views/smi/smi-detail"
            ),
          meta: {
            parent: "smi",
            access_group: [1]
          }
        },

        // smi detail
        {
          path: "/smi/:id",
          name: "smi-detail",
          component: () =>
            import(
              /* webpackChunkName: "smi-detail" */
              "./views/smi/smi-detail"
            ),
          meta: {
            parent: "smi",
            access_group: [1]
          }
        }, // category smi list
        {
          path: "/googleforms/list",
          name: "googleforms-list",
          component: () =>
            import(
              /* webpackChunkName: "category-evemts" */
              "./views/googleforms"
            ),
          meta: {
            dataUrl: "googleforms",
            iconName: "bar-chart",
            hideProd: true,
            parent: "googleforms",
            title: {
              uz: "Опросы",
              oz: "Опросы",
              ru: "Опросы",
              en: "Poll"
            },
            access_group: [1]
          }
        },

        // googleforms create
        {
          path: "/googleforms-create",
          name: "googleforms-create",
          component: () =>
            import(
              /* webpackChunkName: "googleforms-create" */
              "./views/googleforms/googleforms-detail"
            ),
          meta: {
            parent: "googleforms",
            access_group: [1]
          }
        },

        // googleforms detail
        {
          path: "/googleforms/:id",
          name: "googleforms-detail",
          component: () =>
            import(
              /* webpackChunkName: "googleforms-detail" */
              "./views/googleforms/googleforms-detail"
            ),
          meta: {
            parent: "googleforms",
            access_group: [1]
          }
        },

        {
          path: "/directory",
          name: "directory",
          component: () =>
            /* webpackChunkName: "wanted-upload" */
            import("./views/directory"),
          meta: {
            title: {
              uz: "Ma'lumotnoma",
              oz: "Маълумотнома",
              ru: "Справочник",
              en: "Directory"
            },

            access_group: [1],

            dataUrl: "directory",
            iconName: "folder",
            hideProd: false
          }
        },

        // statistic
        {
          path: "/statistic",
          name: "statistic",
          component: () =>
            /* webpackChunkName: "statistic" */
            import("./views/statistic"),
          meta: {
            title: {
              uz: "Statistika",
              oz: "Статистика",
              ru: "Статистика",
              en: "Statistics"
            },

            access_group: [1],

            dataUrl: "statistic",
            iconName: "stock"
          }
        },

        // leadership
        {
          path: "/leadership",
          name: "leadership",
          component: () =>
            /* webpackChunkName: "leadership" */
            import("./views/leadership"),
          meta: {
            title: {
              uz: "Rahbariyat",
              oz: "Раҳбарият",
              ru: "Руководство",
              en: "Leadership"
            },

            dataUrl: "leadership",
            iconName: "profile",
            hideProd: true,
            access_group: [1]
          }
        },

        // leadership create
        {
          path: "/leadership/create",
          name: "leadership-create",
          component: () =>
            /* webpackChunkName: "leadership-create" */
            import("./views/leadership/detail"),
          meta: {
            parent: "leadership",
            access_group: [1]
          }
        },

        // leadership detail
        {
          path: "/leadership/:id",
          name: "leadership-detail",
          component: () =>
            /* webpackChunkName: "leadership-detail" */
            import("./views/leadership/detail"),
          meta: {
            parent: "leadership",
            access_group: [1]
          }
        },
        // bloggers
        {
          path: "/bloggers",
          name: "bloggers",
          component: () =>
            /* webpackChunkName: "bloggers" */
            import("./views/bloggers"),
          meta: {
            title: {
              uz: "Блогеры",
              oz: "Блогеры",
              ru: "Блогеры",
              en: "Bloggers"
            },

            access_group: [1],

            dataUrl: "bloggers",
            iconName: "profile",
            hideProd: false
          }
        },

        // bloggers create
        {
          path: "/bloggers/create",
          name: "bloggers-create",
          component: () =>
            /* webpackChunkName: "bloggers-create" */
            import("./views/bloggers/detail"),
          meta: {
            parent: "bloggers",
            access_group: [1]
          }
        },

        // bloggers detail
        {
          path: "/bloggers/:id",
          name: "bloggers-detail",
          component: () =>
            /* webpackChunkName: "bloggers-detail" */
            import("./views/bloggers/detail"),
          meta: {
            parent: "bloggers",
            access_group: [1]
          }
        },
        // department
        {
          path: "/department",
          name: "department",
          component: () =>
            /* webpackChunkName: "department" */
            import("./views/department"),
          meta: {
            title: {
              uz: "Tuzulma",
              oz: "Тузулма",
              ru: "Подразделение",
              en: "Department"
            },

            dataUrl: "department",
            iconName: "cluster",
            hideProd: true,
            access_group: [1]
          }
        },

        // department create
        {
          path: "/department/create",
          name: "department-create",
          component: () =>
            /* webpackChunkName: "department-create" */
            import("./views/department/detail"),
          meta: {
            parent: "department",
            access_group: [1]
          }
        },

        // department detail
        {
          path: "/department/:id",
          name: "department-detail",
          component: () =>
            /* webpackChunkName: "department-detail" */
            import("./views/department/detail"),
          meta: {
            parent: "department",
            access_group: [1]
          }
        },

        // galereya
        {
          path: "/gallery",
          name: "gallery",
          component: () =>
            /* webpackChunkName: "gallery" */
            import("./views/gallery"),
          meta: {
            title: {
              uz: "Galereya",
              oz: "Галерея",
              ru: "Галерея",
              en: "Gallery"
            },

            access_group: [1],

            dataUrl: "gallery",
            iconName: "picture",
            hideProd: false
          }
        },

        // galereya create
        {
          path: "/gallery/create/:type",
          name: "gallery-create",
          component: () =>
            /* webpackChunkName: "gallery-type-create" */
            import("./views/gallery/detail"),
          meta: {
            parent: "gallery",
            access_group: [1]
          }
        },

        // galereya detail
        {
          path: "/gallery/:id",
          name: "gallery-detail",
          component: () =>
            /* webpackChunkName: "gallery-detail" */
            import("./views/gallery/detail"),
          meta: {
            parent: "gallery",
            access_group: [1]
          }
        },

        // contacts
        {
          path: "/contacts",
          name: "contacts",
          component: () =>
            /* webpackChunkName: "contacts" */
            import("./views/contacts"),
          meta: {
            title: {
              uz: "Bog'lanish",
              oz: "Боғланиш",
              ru: "Контакты",
              en: "Contacts"
            },

            dataUrl: "contacts",
            iconName: "contacts",
            hideProd: true,
            access_group: [1]
          }
        },
        // image-store
        {
          path: "/image-store",
          name: "image-store",
          component: () =>
            /* webpackChunkName: "image-store" */
            import("./views/image-store"),
          meta: {
            title: {
              uz: "Rasmni saqlash",
              oz: "Расмни саклаш",
              ru: "Хранилище изображений",
              en: "Image store"
            },

            dataUrl: "image-store",
            iconName: "file-image",
            hideProd: false,

            access_group: [1, 2]
          }
        },
        // faq
        {
          path: "/faq",
          name: "faq",
          component: () => /* webpackChunkName: "faq" */ import("./views/faq"),
          meta: {
            title: {
              uz: "Savol va javoblar",
              oz: "Савол ва жавоблар",
              ru: "Вопросы и ответы",
              en: "Questions and answers"
            },

            dataUrl: "faq",
            iconName: "question-circle",
            hideProd: true,
            access_group: [1]
          }
        },

        // faq create
        {
          path: "/faq/create",
          name: "faq-create",
          component: () =>
            /* webpackChunkName: "faq" */
            import("./views/faq/detail"),
          meta: {
            parent: "faq",
            access_group: [1]
          }
        },

        // faq detail
        {
          path: "/faq/:id",
          name: "faq-detail",
          component: () =>
            /* webpackChunkName: "faq" */
            import("./views/faq/detail"),
          meta: {
            parent: "faq",
            access_group: [1]
          }
        },

        // forms
        {
          path: "/forms",
          name: "forms",
          component: () =>
            /* webpackChunkName: "forms" */
            import("./views/forms/forms-index"),
          meta: {
            title: {
              uz: "Формы",
              oz: "Формы",
              ru: "Формы",
              en: "Формы"
            },
            iconName: "form",
            dataUrl: "forms",
            hideProd: true,
            access_group: [1]
          }
        },

        {
          path: "/forms/:id",
          name: "forms-detail",
          component: () =>
            /* webpackChunkName: "forms-detail" */
            import("./views/forms/detail"),
          meta: {
            parent: "forms",
            access_group: [1]
          }
        },

        //
        // newspaper
        //
        {
          path: "/newspaper",
          name: "newspaper",
          component: () =>
            /* webpackChunkName: "newspaper" */
            import("./views/newspaper/newspaper-index"),
          meta: {
            title: {
              uz: "Газета",
              oz: "Газета",
              ru: "Газета",
              en: "Газета"
            },
            access_group: [1],
            iconName: "solution",
            dataUrl: "newspaper",
            hideProd: false
          }
        },

        // newspaper create
        {
          path: "/newspaper/create",
          name: "newspaper-create",
          component: () =>
            /* webpackChunkName: "newspaper-slug" */ import(
              "./views/newspaper/newspaper-create"
            ),
          meta: {
            access_group: [1]
          }
        },

        // newspaper edit
        {
          path: "/newspaper/:slug/edit",
          name: "newspaper-slug",
          component: () =>
            /* webpackChunkName: "newspaper-slug" */ import(
              "./views/newspaper/newspaper-slug"
            ),
          meta: {
            access_group: [1]
          }
        },

        //
        // banners
        //
        {
          path: "/banners",
          name: "banners",
          component: () =>
            /* webpackChunkName: "banners-index" */
            import("./views/banners/banners-index"),
          meta: {
            title: {
              uz: "Баннеры",
              oz: "Баннеры",
              ru: "Баннеры",
              en: "Баннеры"
            },
            iconName: "flag",
            dataUrl: "banners",
            access_group: [1],
            hideProd: false
          }
        },

        // banners create
        {
          path: "/banners/create",
          name: "banners-create",
          component: () =>
            /* webpackChunkName: "banners-create" */ import(
              "./views/banners/banners-create"
            ),
          meta: {
            access_group: [1]
          }
        },

        // banners edit
        {
          path: "/banners/:id/edit",
          name: "banners-id",
          component: () =>
            /* webpackChunkName: "banners-id" */ import(
              "./views/banners/banners-id"
            ),
          meta: {
            access_group: [1]
          }
        },

        //
        // settings
        //
        {
          path: "/settings",
          name: "settings",
          component: () => import("./views/settings"),
          meta: {
            access_group: [1],
            title: {
              uz: "Sozlamalar",
              oz: "Созламалар",
              ru: "Настройки",
              en: "Settings"
            },
            iconName: "control",
            dataUrl: "settings"
          }
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./layouts/loginWindow")
    },
    {
      // Not Found
      path: "*",
      // redirect: '/',
      component: () =>
        import(/* webpackChunkName: "anypage" */ "./layouts/notFound")
    }
  ]
  // mode: 'history'
})
